import React, {useMemo} from 'react';
import StatCard from "./StatCard";
import IMG from "../../constants/image";
import {isMobile} from "react-device-detect";
import {isEmpty} from "lodash";
import {useNavigate} from "react-router-dom";
import {PATH} from "../../constants";

const STATUS_CONFIG = {
    published: {
        icon: IMG.icon.cubeGreen,
        label: "Đang hiển thị",
        bgColor: "bg-green-50"
    },
    draft: {
        icon: IMG.icon.documentCheckYellow,
        label: "Chờ duyệt",
        bgColor: "bg-yellow-50"
    },
    proposed: {
        icon: IMG.icon.eyeGray,
        label: isMobile ? "Bị ẩn" : "Đang bị ẩn",
        bgColor: "bg-gray-50"
    },
    rejected: {
        icon: IMG.icon.warningRed,
        label: "Bị từ chối",
        bgColor: "bg-red-50"
    }
};
const ProductStats = ({stats}) => {
    const navigate = useNavigate();
    const statusCounts = useMemo(() => {
        if (isEmpty(stats)) {
            return {
                statusCounts: {},
                total: 0
            };
        }
        // Create a lookup object for counts and calculate total in one pass
        const counts = stats.reduce((acc, stat) => {
            acc.counts[stat.status] = stat.count;
            acc.total += stat.count;
            return acc;
        }, {counts: {}, total: 0});

        return counts.counts || {}
    }, [stats]);
    const onHandleClick = (status) => {
        navigate(`${PATH.MANAGING_PRODUCT}?status=${status}`)
    }
    return (
        <div className="p-4 bg-white rounded-lg md:rounded-xl text-center">
            <h2 className="text-sm md:font-bold mb-3">
                Số sản phẩm trên gian hàng của bạn là: <span className="text-xl font-bold">{statusCounts?.all}</span>
            </h2>
            <div className="grid grid-cols-4 gap-2">
                {Object.entries(STATUS_CONFIG).map(([status, config]) => (
                    <StatCard
                        key={status}
                        icon={config.icon}
                        count={statusCounts[status] || 0}
                        label={config.label}
                        bgColor={config.bgColor}
                        onHandleClick={() => onHandleClick(status)}
                    />
                ))}
            </div>
        </div>
    );
}
export default ProductStats;